/** @format */

const ApiCommon = {
  getProductMenu: '/monitor/?Action=DescribeCloudServiceMenu&Version=2021-01-01',
  getProudctGroup: '/monitor/?Action=DescribeCloudServiceCategories&Version=2022-01-01',
  getAlertUser: '/monitorapi/users/getAlertUser', // 获取命名空间
  getUserGroup: '/monitorapi/usergroups/getUserGroup', // 获取指标
  // 获取项目list
  getAccountAllProjectList: '/monitor/?Action=GetAccountAllProjectList&Version=2015-11-01',
  // 获取实例组List
  getGroupList: '/monitor/?Action=DescribeInstanceGroupList&Version=2021-01-01',
  // 查询产品线监控项
  getProductMetricList: '/monitor/?Action=DescribeProductMetrics&Version=2021-01-01'
}
export default ApiCommon
